<template>
  <a-upload name="avatar" class="avatar-uploader" :customRequest="uploadFun" :show-upload-list="false" :before-upload="beforeUpload" @change="handleChange">
    <img class="has-upload" v-if="imgUrl" src="../../../static/images/word.png" alt="" />
    <div class="no-upload" v-else>
      <svg-icon v-if="!loading" icon-class="add" class="svg-icon cr-mb-1"></svg-icon>
      <a-icon v-else class="cr-mb-1 cr-icon cr-text-primary" type="loading" />
      <div class="cr-text-black-1 ct-mt-1" v-html="upText"></div>
    </div>
  </a-upload>
</template>

<script>
import { uploadFile } from '@/api/caseDetail'
export default {
  model: {
    prop: 'imgUrl',
    event: 'change'
  },
  props: {
    fileUrl: String,
    imgUrl: String,
    upText: {
      type: String,
      default: '营业执照副本扫描件'
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    // 自定义上传方法
    async uploadFun(val) {
      let file = val.file
      const formData = new FormData()
      formData.append('file', file)
      try {
        const res = await uploadFile(formData)
        this.$emit('change', res.data)
      } catch (error) {
        console.log('上传失败')
        this.loading = false
      }
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
      }
      if (info.file.status === 'done') {
        this.loading = false
      }
    },
    beforeUpload(file) {
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.has-upload {
  width: 160px;
  height: 120px;
  cursor: pointer;
  border-radius: 2px;
  padding: 10px;
}
.avatar-uploader {
  width: 160px;
  height: 120px;
  font-size: 14px;
  .no-upload {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px dashed @theme-color;
    cursor: pointer;
    border-radius: 2px;
    text-align: center;
    .svg-icon {
      height: 36px;
      width: 36px;
    }
    .cr-icon {
      font-size: 32px;
    }
  }
  ::v-deep .ant-upload {
    width: 160px;
    height: 120px;
    background: rgba(71, 186, 151, 0.07);
  }
}
</style>
